export default __webpack_public_path__ + "static/media/avatar_cheshire_cat2.d39ffcd7.mp3";